import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { workClient } from "../clients/workClient";

const settingsCategoriesSchema = z.array(
  z.object({
    id: z.number().int().positive(),
    name: z.string(),
    isGlobal: z.boolean(),
  }),
);

export async function fetchSettingsCategories(
  customerId: string,
  facilityId: string,
) {
  const response = await workClient.v1.customers[":customerId"].facilities[
    ":facilityId"
  ].settings.categories.$get({ param: { customerId, facilityId } });
  if (!response.ok)
    throw new Error(`Failed to fetch categories: ${response.status}`);
  return settingsCategoriesSchema.parse(await response.json());
}

export function useSettingsCategories(
  customerId: string,
  facilityId: string,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ["settings-categories", customerId, facilityId],
    queryFn: () => fetchSettingsCategories(customerId, facilityId),
    enabled: enabled && !!customerId && !!facilityId,
    meta: { errorMessage: "Failed to load categories" },
  });
}
